import "./styles.less";

import React, { useContext } from "react";

import { Button, Collapse, Tooltip, Typography } from "antd";
import { CalendarFilled, ContactsFilled, DownOutlined } from "@ant-design/icons";

import { DateRange } from "./DateRange/web";
import { Seasons } from "./Seasons/web";
import { useTemporalFilter } from "./TemporalFilter.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

const { Panel } = Collapse;
const { Title } = Typography;

export const TemporalFilter = ({
	filterChanged,
	labeled = false,
	collapsable = false,
	isInFilters = false,
	showSeasonInput = false,
	handleChangeSeason
}) => {
	const { theme } = useTheme();
	const {
		isTemporal,
		filters: { dateTo, dateFrom, season },
	} = useTemporalFilter();
	const { country_code } = useContext(ConfigStateContext);

	if (!isTemporal) return null;


	const extraIcon = () => (
		<Tooltip
			arrowPointAtCenter
			placement="topLeft"
			overlayInnerStyle={{ fontSize: 12, padding: 8 }}
			color={theme.colors.secondaryHoverColor}
			title="Filtro Activo">
			<span className="active-filter"></span>
		</Tooltip>
	);

	const filter = (
		<>
			{showSeasonInput ? (
				<Seasons filterChanged={filterChanged} />
			) : (
				<DateRange filterChanged={filterChanged} />
			)}
			{(isInFilters || country_code !== "ce3") && (
				<Button
					className="btn-search-seasons"
					type="text"
					onClick={() => handleChangeSeason(!showSeasonInput)}
					icon={showSeasonInput ? <CalendarFilled /> : <ContactsFilled />}
				>
					<Typography.Text>
						{showSeasonInput ? "Buscar por Calendario" : "Buscar por Temporada"}
					</Typography.Text>
				</Button>
			)}
		</>
	);

	return (
		<div className="filter temporal-filter">
			{collapsable ? (
				<Collapse
					ghost
					bordered={false}
					expandIconPosition="right"
					defaultActiveKey={dateFrom || dateTo || season ? "true" : "false"}
					expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}>
					<Panel
						extra={(dateFrom || dateTo || season) && extraIcon()}
						header={"Temporada" + " / " + "Fechas"}
						key={"true"}>
						{filter}
					</Panel>
				</Collapse>
			) : (
				<>
					{labeled && (
						<Title level={4}>{showSeasonInput ? "Temporada" : "Fechas"}</Title>
					)}
					{filter}
				</>
			)}
		</div>
	);
};
